export function formatMoney(amount, currency) {
  const resolvedCurrency = currency || 'CDF';
  return new Intl.NumberFormat('fr-FR', {
    style: 'currency',
    currency: resolvedCurrency,
    maximumFractionDigits: resolvedCurrency === 'CDF' ? 0 : 2,
  }).format(Number(amount || 0));
}

export function convertCurrency(amount, fromCurrency, toCurrency, rates) {
  const numericAmount = Number(amount || 0);

  if (fromCurrency === toCurrency) {
    return numericAmount;
  }

  if (fromCurrency === 'USD' && toCurrency === 'CDF') {
    return numericAmount * Number(rates?.usdToCdfRate || 0);
  }

  if (fromCurrency === 'CDF' && toCurrency === 'USD') {
    return numericAmount * Number(rates?.cdfToUsdRate || 0);
  }

  return numericAmount;
}
